import type { ReactNode } from "react";
import { ToWords } from "to-words/en-IN";
import AuthlessPrintChrome from "@/components/common-receipt/AuthlessPrintChrome";
import { useAuthlessPrintRow } from "@/components/common-receipt/use-authless-print-row";
import ReceiptPrintLayout from "@/components/receipt-layout";
import { useHardcopyBorders } from "@/theme/useHardcopyBorders";
import { formatDisplayDateTime } from "@/utils/date-format";
// import { MARKAZ_LIST } from "@/constants";
// import { getHijriYear } from "@/utils/hijri-date-utils";

type NiyaazReceiptRow = {
  HOFName?: string;
  amount?: number;
  mode?: string;
  formNo?: string;
  receiptNo?: string;
  HOFId?: string;
  markaz?: string;
  createdAt?: string;
};

const ReceiptPrint = () => {
  const { solid1, solid1Soft, solid5 } = useHardcopyBorders();
  const { data, error } = useAuthlessPrintRow<NiyaazReceiptRow>({
    location: "niyaazReceipts",
    idFromSearchParam: "receiptId",
  });

  return (
    <AuthlessPrintChrome data={data} error={error}>
      {(receiptData) => {
        const toWords = new ToWords();

        const LabelValue = ({
          label,
          value,
          noBorder,
        }: {
          label: string;
          value: ReactNode;
          noBorder?: boolean;
        }) => (
          <div style={{ borderBottom: !noBorder ? solid1 : undefined }}>
            <div style={{ textAlign: "right", padding: "5px", fontSize: "13px" }}>{label}</div>
            <div style={{ fontSize: "15px", textAlign: "right", padding: "5px" }}>{value}</div>
          </div>
        );

        // const markazLabel = receiptData.markaz
        //   ? (MARKAZ_LIST[receiptData.markaz as keyof typeof MARKAZ_LIST] ?? "")
        //   : "";

        return (
          <ReceiptPrintLayout subTitle="NIYAAZ TANZEEM">
            <div style={{ display: "flex", width: "100%" }}>
              <div
                className="u-col u-col-82p27"
                style={{ boxSizing: "border-box", padding: "0", borderTop: solid5 }}
              >
                <div style={{ padding: "20px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingRight: "10px" }}>نام</div>
                    <div style={{ flex: "3", borderBottom: solid1Soft }}>{receiptData.HOFName}</div>
                    <div style={{ paddingLeft: "10px" }}>حفظ الله تعالى</div>
                  </div>
                </div>
                <div style={{ textAlign: "center", padding: "10px" }}>بعد السلام الجميل</div>
                <div style={{ padding: "10px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ flex: "3", paddingRight: "10px", borderBottom: solid1Soft }}>
                      {toWords.convert(Number(receiptData.amount ?? 0))} Only /-
                    </div>
                    <div style={{ flex: "0.5", paddingRight: "10px", textAlign: "center" }}>
                      انكه
                    </div>
                    <div style={{ flex: "1", borderBottom: solid1Soft }}>
                      ₹ {Intl.NumberFormat("en-IN").format(receiptData.amount || 0)}
                    </div>
                    <div style={{ flex: "2", paddingLeft: "10px", textAlign: "right" }}>
                      اٰپ طرف سي
                    </div>
                  </div>
                </div>

                <div style={{ textAlign: "center", padding: "10px" }}>
                  {/* ما &ldquo;<strong>Ashara Mubarakah {getHijriYear()}</strong>&rdquo; */}
                  ما &ldquo;<strong>Ashara Mubarakah 1448</strong>&rdquo;
                </div>

                <div style={{ padding: "10px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ flex: "4", paddingRight: "10px" }}>سنة عيسوي وصول تهيا چهے</div>
                    <div style={{ flex: "1", borderBottom: solid1Soft }}></div>
                    <div style={{ flex: "2", borderBottom: solid1Soft }}>
                      {receiptData.createdAt ? formatDisplayDateTime(receiptData.createdAt) : ""}
                    </div>
                    <div style={{ flex: "1.2", paddingLeft: "10px", textAlign: "right" }}>
                      من شهر
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="u-col u-col-17p73"
                style={{
                  boxSizing: "border-box",
                  borderTop: solid5,
                  borderLeft: solid5,
                }}
              >
                <LabelValue
                  label="تاريخ"
                  value={receiptData.createdAt ? formatDisplayDateTime(receiptData.createdAt) : ""}
                />
                <LabelValue label="Payment Mode" value={receiptData.mode} />
                <LabelValue label="Form No" value={receiptData.formNo} />
                <LabelValue label="رسيد نمبر" value={receiptData.receiptNo} />
                <LabelValue label="HOF ITS" value={receiptData.HOFId} noBorder />
              </div>
            </div>
          </ReceiptPrintLayout>
        );
      }}
    </AuthlessPrintChrome>
  );
};

export default ReceiptPrint;
